<template>
  <div id="configuratorDesktop">
      <div id="navigation" v-if="!getMobile">
        <div style="position: relative;">
          <Navigation/>
        </div>
      </div>
      <NavigationMobile v-if="getMobile"/>

      <div v-if="!getMobile" class="leftRightElement">
        <!-- <div style="position: relative; width: 100%; height: 100%;"> -->
          <div v-if="!hoverTable && !hoverTableOffice && !hoverBench && !hoverStool && !hoverShelf && !hoverFrame"  class="bakgroundImg" id="bakgroundImg"></div>
          <div v-if="hoverTable" class="bakgroundImg" id="bakgroundImgTable"></div>
          <!-- <div v-if="hoverTableOffice" class="bakgroundImg" id="bakgroundImgTableOffice"></div> -->
          <div v-if="hoverShelf" class="bakgroundImg" id="bakgroundImgShelf"></div>
          <div v-if="hoverBench" class="bakgroundImg" id="bakgroundImgBench"></div>
          <div v-if="hoverStool" class="bakgroundImg" id="bakgroundImgStool"></div>
          <!-- <div v-if="hoverFrame" class="bakgroundImg" id="bakgroundImgFrame"></div> -->
        <div>
          <h1 id="title">
            {{getText.title}}
          </h1>
          <ul>
            <li class="link">
              <router-link to="/configuratorTableDesktop">
                <v-btn class="ma-2" color="var(--accentColor)"
                    @mouseover="hoverTable = true"
                    @mouseleave="hoverTable = false"
                    x-large
                    block>
                  <span style="color:var(--mainColor);">
                    {{getText.table}}
                  </span>
                </v-btn>
              </router-link>
            </li>
            <!-- <li class="link">
              <router-link to="/configuratorTableOfficeDesktop">
                <v-btn class="ma-2" color="var(--accentColor)"
                    @mouseover="hoverTableOffice = true"
                    @mouseleave="hoverTableOffice = false"
                    x-large
                    block>
                  <span style="color:var(--mainColor);">
                    {{getText.tableOffice}}
                  </span>
                </v-btn>
              </router-link>
            </li> -->
            <!-- <li class="link">
              <router-link to="/configuratorShelfDesktop">
                <v-btn class="ma-2" color="var(--accentColor)"
                    @mouseover="hoverShelf = true"
                    @mouseleave="hoverShelf = false"
                    x-large
                    block>
                  <span style="color:var(--mainColor);">
                    {{getText.shelf}}
                  </span>
                </v-btn>
              </router-link>
            </li> -->
            <li class="link">
              <router-link to="/configuratorBenchDesktop">
                <v-btn class="ma-2" color="var(--accentColor)"
                    @mouseover="hoverBench = true"
                    @mouseleave="hoverBench = false"
                    x-large
                    block>
                  <span style="color:var(--mainColor);">
                    {{getText.bench}}
                  </span>
                </v-btn>
              </router-link>
            </li>
            <li class="link">
              <router-link to="/configuratorStoolDesktop">
                <v-btn class="ma-2" color="var(--accentColor)"
                    @mouseover="hoverStool = true"
                    @mouseleave="hoverStool = false"
                    x-large
                    block>
                  <span style="color:var(--mainColor);">
                    {{getText.stool}}
                  </span>
                </v-btn>
              </router-link>
            </li>
            <!-- <li class="link">
              <router-link to="/configuratorFrameDesktop">
                <v-btn class="ma-2" color="var(--accentColor)"
                    @mouseover="hoverFrame = true"
                    @mouseleave="hoverFrame = false"
                    x-large
                    block>
                  <span style="color:var(--mainColor);">
                    {{getText.frameProduct}}
                  </span>
                </v-btn>
              </router-link>
            </li> -->
          </ul>
        </div>
      </div>


    <div v-if="getMobile">
      <div id="mobile">
        <div style="position: relative; width: 100vw; height: 40%;">
          <v-img src="./../../public/img/gerüstbohlen-möbel-konfigurieren.jpeg" alt="gerüstbohlen tisch, regal und hocker möbel" width="100%" height="100%"></v-img>
        </div>
        <div style="height: 430px; position: absolute; bottom: 0;">
          <h1 id="titleMobile" class="backgroundShade">
            {{getText.title}}
          </h1>
          <ul style="padding-left: 0;">
            <li class="linkMobile">
              <router-link to="/configuratorTableMobile">
                <v-btn class="ma-2 buttonMobile" color="var(--accentColor)">
                  <span style="color:var(--mainColor);">
                    {{getText.table}}
                  </span>
                </v-btn>
              </router-link>
            </li>
            <!-- <li class="linkMobile">
              <router-link to="/configuratorTableOfficeMobile">
                <v-btn class="ma-2 buttonMobile" color="var(--accentColor)">
                  <span style="color:var(--mainColor);">
                    {{getText.tableOffice}}
                  </span>
                </v-btn>
              </router-link>
            </li> -->
            <!-- <li class="linkMobile">
              <router-link to="/configuratorShelfMobile">
                <v-btn class="ma-2 buttonMobile" color="var(--accentColor)">
                  <span style="color:var(--mainColor);">
                    {{getText.shelf}}
                  </span>
                </v-btn>
              </router-link>
            </li> -->
            <li class="linkMobile">
              <router-link to="/configuratorBenchMobile">
                <v-btn class="ma-2 buttonMobile" color="var(--accentColor)">
                  <span style="color:var(--mainColor);">
                    {{getText.bench}}
                  </span>
                </v-btn>
              </router-link>
            </li>
            <li class="linkMobile">
              <router-link to="/configuratorStoolMobile">
                <v-btn class="ma-2 buttonMobile" color="var(--accentColor)">
                  <span style="color:var(--mainColor);">
                    {{getText.stool}}
                  </span>
                </v-btn>
              </router-link>
            </li>
            <!-- <li class="linkMobile">
              <router-link to="/configuratorFrameMobile">
                <v-btn class="ma-2 buttonMobile" color="var(--accentColor)">
                  <span style="color:var(--mainColor);">
                    {{getText.frameProduct}}
                  </span>
                </v-btn>
              </router-link>
            </li> -->
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation.vue'
import NavigationMobile from '@/components/NavigationMobile.vue'

export default {
  name: 'ConfiguratorDesktop',
  components: {
    Navigation,
    NavigationMobile
  },
  data() {
    return{
      hoverTable: false,
      hoverTableOffice: false,
      hoverBench: false,
      hoverStool: false,
      hoverShelf: false,
      hoverFrame: false
    }
   },
   mounted (){
     this.$store.dispatch("setNavbarActive", 1);
      this.$store.dispatch("showFooter", false)
   },
   destroyed(){
      this.$store.dispatch("showFooter", true)
   },
   computed: {
     getMobile(){return this.$store.getters.getAnimationProperties.mobile;},
     getText(){return this.$store.getters.getText.configurator;},
   },
   methods: {
   }
}
</script>

<style scoped>
.buttonMobile{
  width: 100%;
  padding: none;
  margin: none;
}
  #mobile{
    position: relative;
    height: 100vh;
    width: 100vw;
    /* display: grid;
    grid-template-rows: 1fr 500px; */
  }
  #configuratorDesktop {
    /* position: fixed; */
    width: 100vw;
    height: calc(100vh - var(--desktopNavigationHeight));
  }
  #bakgroundImg{
    background-image: url('./../../public/img/gerüstbohlen-möbel-konfigurieren.jpeg');
  }
  .bakgroundImg{
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: left;
    min-height: 100vh;
  }
  #bakgroundImgTable{
    background-image: url('./../../public/img/gerüstbohlen-tisch-konfigurator.jpeg');
  }
  #bakgroundImgTableOffice{
    background-image: url('./../../public/img/gerüstbohlen-tischOffice-konfigurator.jpeg');
  }
  #bakgroundImgShelf{
    background-image: url('./../../public/img/gerüstbohlen-regal-konfigurator.jpeg');
  }
  #bakgroundImgBench{
    background-image: url('./../../public/img/gerüstbohlen-bank-konfigurator.jpeg');
  }
  #bakgroundImgStool{
    background-image: url('./../../public/img/gerüstbohlen-hocker-konfigurator.jpeg');
  }
  #bakgroundImgFrame{
    background-image: url('./../../public/img/gerüstbohlen-rahmen-konfigurator.jpeg');
  }
  #title{
    margin: 120px 30px 80px 30px;
  }
  #titleMobile{
    margin: 0 20px 0 20px;
    padding: 60px 0 20px 0;
  }
  .backgroundShade{
    background-color: #FFFFFFAA;
  }
  .link{
    text-decoration: none;
    margin: 30px 0;
    padding: 0 20%;
    font-size: 20px !important;
    width: 100%;
  }
  .linkMobile{
    margin: 0 80px;
  }
  .buttonMobile{
    position: relative;
    left: -8px;
  }
  a:link {
  text-decoration: none;
}

a:visited {
  text-decoration: none;
}
  ul{
    list-style-type: none;

  }

</style>
